export default __webpack_public_path__ + "static/media/share-email-icon.5ee4c52a.png";